import React from 'react'
import {TwUserStatus} from './containers'
import {UserStatusProps} from './types'

export const UserStatus = ({
  userIsInDoNotDisturbMode,
  userStatus,
  size,
  hideOutline,
  outlineSize,
  outlineColor,
  className
}: UserStatusProps) => (
  <TwUserStatus
    $size={size}
    $hideOutline={hideOutline}
    $outlineSize={outlineSize}
    $outlineColor={outlineColor}
    $online={userStatus === 'online'}
    $doNotDisturb={userIsInDoNotDisturbMode}
    className={className}
  />
)
